import {
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Dataset_Quote, Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const getOneQuoteInputTemplate = (key: string) => ({
  ...Input_Template_Dataset_Quote,
  key,
  type: FlowNodeInputTypeEnum.hidden,
});

export const KnowledgeConcat: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.knowledgeConcat,
  flowType: FlowNodeTypeEnum.knowledgeConcat,
  templateType: ModuleTemplateTypeEnum.tools,
  avatar: '/imgs/module/concat.svg',
  name: '知识库搜索引用合并',
  description: '可以将多个知识库搜索结果进行合并输出。使用 RRF 的合并方式进行最终排序输出。',
  inputs: [
    Input_Template_Switch,
    {
      key: ModuleInputKeyEnum.knowledgeMaxRows,
      type: FlowNodeInputTypeEnum.slider,
      label: '最大 Tokens',
      value: 1500,
      valueType: ModuleIOValueTypeEnum.number,
      showTargetInApp: false,
      showTargetInPlugin: false,
      min: 100,
      max: 3000,
      markList: {
        '100': '100',
        '3000': '3000',
      },
    },
    getOneQuoteInputTemplate('defaultQuote'),
  ],
  outputs: [
    {
      key: ModuleOutputKeyEnum.knowledgeResults,
      label: '知识库引用',
      type: FlowNodeOutputTypeEnum.source,
      valueType: ModuleIOValueTypeEnum.datasetQuote,
      targets: [],
    },
    Output_Template_Finish,
  ],
};
